module.exports = __webpack_public_path__ + "static/media/gl.f7435230.svg";